
  import { mapState } from 'vuex'
  export default {
    data: () => ({
      wallet: 1
    }),
    computed: {
      ...mapState({
        onHoldWallet: state => state.player.onHoldWallet,
        player: state => state.player.player,
        activityWallet: state => state.player.activityWallet,
        missionsSettings: state => state.activities['mission-reward'].missionsSettings
      })
    }
  }
